'use client'

import { useGetProjectId } from '@/app/slugs'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { GetProjectSeoReportParams } from '@/shared/api/end-points/project'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { SeoReportResponse } from '../../lib'
import services from '../services'

const useGetSeoReport = (partialParams?: GetProjectSeoReportParams) => {
  const projectIdParams = useGetProjectId()
  const params = partialParams || projectIdParams

  const queryKey = [queryKeys((a, m) => a.project.getProjectSeoReport(params) + m.get)]

  const query = useQuery({
    queryKey,
    queryFn: async () => apiResponseHandler(await services.getSeoReport(params)),
    enabled: !!params.projectId,
    refetchOnWindowFocus: false,
  })

  return {
    ...query,
    queryKey,
  } as UseQueryResult<SeoReportResponse> & { queryKey: typeof queryKey }
}

export default useGetSeoReport
